// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jELA","col":"styles_col__OypZs","actions":"styles_actions__2yiql","conflict":"styles_conflict__3kar_"};